import type { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { ScDivider } from './styled';

export const Divider: FC = () => {
  const { t } = useTranslation('common');
  return <ScDivider>{t('modals.authorization.or')}</ScDivider>;
};
